import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { SeguroService } from '../../_services/seguro.service';
import { Seguro } from '../../_models/seguro';
import { Cuestionario } from '../../_models/cuestionario';
import { forkJoin } from 'rxjs';
import { CuestionarioService } from '../../_services/cuestionario.service';
import { SeguroPlanService } from '../../_services/seguro-plan.service';
import { SeguroPlan } from '../../_models/seguro-plan';
import { Table } from 'primeng/table';
import {SegurosTiposPersonas} from '../../_models/seguros-tipos-personas';
import {SegurosTiposPersonasService} from '../../_services/seguros-tipos-personas.service';

@Component( {
  selector: 'app-seguro-detalle',
  templateUrl: 'seguro-detalle.component.html'
} )

export class SeguroDetalleComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  seguro: Seguro;
  lisSegurosPlan: SeguroPlan[] = [];
  cuestionario: Cuestionario;
  tabSeleccionado = 'SEGU';
  formulario: FormGroup;
  submitted = false;
  lisCuestionariosTodos: Cuestionario[] = [];
  carTabla = true;
  columnas: any[];
  listaSegurosTipoPersonas: SegurosTiposPersonas[] = [];
  segurosTipoPersonas: any = null;
  @ViewChild('dt') tabla: Table;

  constructor( private serSeguro: SeguroService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               private serCuestionarios: CuestionarioService,
               private serSeguroPlan: SeguroPlanService,
               private segurosTiposPersonas: SegurosTiposPersonasService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined ) {
        this.serSeguro.obtenerPorId( params[ 'id' ] ).subscribe( seguro => {
          this.seguro = seguro;
          this.seguro.descripcion = this.seguro.descripcion ? this.seguro.descripcion : '';
          this.seguro.descripcionCobertura = this.seguro.descripcionCobertura ? this.seguro.descripcionCobertura : '';
          this.carServiciosIniciales();
        } );
      }
    } );
  }

  carServiciosIniciales() {


    forkJoin( this.serCuestionarios.listadoConRespuesta(),
      this.serSeguroPlan.listadoPorIdSeguro( this.seguro.idSeguro ),
      this.segurosTiposPersonas.listadoPorIdSeguro(this.seguro.idSeguro)
      ).subscribe( ( [ cuestionarios, segurosPlan, segurosTiposPersonas ] ) => {
      this.lisCuestionariosTodos = cuestionarios;
      this.lisSegurosPlan = segurosPlan;
      this.listaSegurosTipoPersonas = segurosTiposPersonas.filter(e => e.indicadorHabilitado);
      this.segurosTipoPersonas =  this.listaSegurosTipoPersonas.map(x => x.tipoPersona);
      this.lisCuestionariosTodos.map( ( s: Cuestionario ) => {
        if ( s.idCuestionario === this.seguro.idCuestionario ) {
          this.cuestionario = s;
        }
      } );

      this.columnas = [
        { field: 'codigo', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_CODPLAN' ), sort: true },
        { field: 'nombre', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_NOMPLAN' ), sort: true },
        { field: 'valor', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_VALORPLAN' ), sort: true }
      ];
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );

  }


  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }


}
